// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"95b575d7","89":"95b575d7","406":"95b575d7","418":"95b575d7","421":"95b575d7","447":"95b575d7","473":"95b575d7","567":"95b575d7","664":"95b575d7","677":"95b575d7","774":"95b575d7","948":"95b575d7"}[chunkId] + ".chunk.css";
};